import { BRAND_SPRITES } from '../assets/brandSprites';

let installed = false;
let pending: Promise<void> | null = null;

export function install3dAssetAliases(): Promise<void> {
  if (installed) return Promise.resolve();
  if (pending) return pending;

  const attempt = import('three')
    .then(({ DefaultLoadingManager }) => {
      DefaultLoadingManager.setURLModifier((url) =>
        url === '/brand/pin-showcase.webp' ? BRAND_SPRITES.logo : url,
      );
      installed = true;
    })
    .finally(() => {
      if (pending === attempt) pending = null;
    });

  pending = attempt;
  return attempt;
}
